export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-2i-40040cbed9c444925c17cec04ffc5ffd.webp";